import { render, staticRenderFns } from "./UserLinePermissionModal.vue?vue&type=template&id=2fb4d773&scoped=true&"
import script from "./UserLinePermissionModal.vue?vue&type=script&lang=js&"
export * from "./UserLinePermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./UserLinePermissionModal.vue?vue&type=style&index=0&id=2fb4d773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4d773",
  null
  
)

export default component.exports